import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {DocumentService} from "../../../../../../core/services/document.service";

@Component({
  selector: 'app-setup-sign-flow-receive',
  templateUrl: './setup-sign-flow-receive.component.html',
  styleUrls: ['./setup-sign-flow-receive.component.scss']
})
export class SetupSignFlowReceiveComponent implements OnInit {

  constructor(
    private router: Router,
    private documentService: DocumentService,
  ) { }

  page: number;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  customerName: '';
  status: '';
  serviceType: '';
  serviceTypeEntity: any;
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  DEFAULT_ROUTER_ON_BACK_LIST = '/home-enterprise/search-document-receive/';
  urlGoBack = this.DEFAULT_ROUTER_ON_BACK_LIST;
  // pdf viewer
  pdfSrc: string;
  zoomLevel = 1;
  documentParentName: string;


  // document
  document = {
    id: '',
    code: '',
    name: '',
    parentId: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    documentTypeEnterpriseId: '',
    customerId: '',
    status: 0,
    filePath: '',
    description: '',
    assignUserId: 0,
    typeId: null,
    isDeleted: true,
    jsonData: '',
    email: '',
    phone: '',
    createdBy: '',
    createdTime: '',
    updatedBy: '',
    updatedTime: '',
    finishDate: '',
    salt: '',
    documentTypeContent: '',
    expiredDate: '',
    contractAttachments: [],
    newUploadContractAttachments: [],
    isSended: false,
    serviceType: null,
    isDifferentEnterprise: false,
  };

  ngOnInit() {
  }

   onBackClick(isCurrentStatus?) {
    if (isCurrentStatus) {
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: isCurrentStatus,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection
        }
      });
    }
    else {
      if (!this.routeLink || this.routeLink == '') {
        this.routeLink = this.urlGoBack;
      }
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection
        }
      });
    }
  }

  openPDFByBrowser(id: string) {
    if (id) {
      this.documentService.downloadPdf(id).subscribe(res => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(res);
        } else {
          const fileURL = URL.createObjectURL(res);
          window.open(fileURL);
        }
      });
    }
  }
  saveSignFlow() {

  }

    zoomIn() {
    this.zoomLevel += .2;
  }

  zoomOut() {
    this.zoomLevel -= .2;
  }
}
